export default class OpenLinksInNewTab {
    #element

    constructor(element) {
        this.#element = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new OpenLinksInNewTab(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.handleElementClick)
    }

    handleElementClick = (e) => {
        let link = e.target.closest('a')

        if (link instanceof HTMLAnchorElement) {
            if (!link.hasAttribute('target')) {
                link.setAttribute('target', '_blank')
            }
        }
    }
}
